import React from "react";
import { useSelector } from "react-redux";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import { selectAuthInfo } from "../../Auth/authSelectors";
import { formatAmountCompact } from "../../../lib/currency";
import { blueTone, toneProps } from "../dashboardTheme";

const MetricCard = ({
  title,
  value = 0,
  currency = "",
  trend = 0,
  diff = null,
  icon = null,
  tone = blueTone(0, 1),
  compareLabel = "",
}) => {
  const positive = trend >= 0;
  const authInfo = useSelector(selectAuthInfo);
  const { className: toneClass, style: toneStyle } = toneProps(tone);

  const formattedValue = formatAmountCompact({
    value,
    country: authInfo?.country,
  });

  return (
    <div className={`erp-kpi${toneClass}`} style={toneStyle}>
      <span className="erp-kpi-top">
        <span className="erp-kpi-title">{title}</span>
        {icon && <span className="erp-icon">{icon}</span>}
      </span>

      <span className="erp-kpi-valuerow">
        <span
          className="erp-kpi-value"
          title={`${Number(value).toLocaleString()} ${currency}`}
        >
          {formattedValue}
        </span>
        {currency && <span className="erp-kpi-unit">{currency}</span>}
      </span>

      <span className="erp-kpi-foot">
        <span className={`erp-trend ${positive ? "up" : "down"}`}>
          {positive ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
          {positive ? "+" : ""}
          {Number(trend).toFixed(2)}%
        </span>
        {(diff !== null || compareLabel) && (
          <span className="erp-kpi-sub">
            {diff !== null && (
              <>
                {positive ? "+" : ""}
                {formatAmountCompact({ value: diff, country: authInfo?.country })}
                {currency && ` ${currency}`}
              </>
            )}
            {compareLabel && ` ${compareLabel}`}
          </span>
        )}
      </span>
    </div>
  );
};

export default MetricCard;
